// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { SchedulingObligationModuleTitle } from './schedulingObligationModuleTitle';
import type { SchedulingObligationCoverage } from './schedulingObligationCoverage';

export interface SchedulingObligation {
  moduleId: string;
  moduleTitle?: SchedulingObligationModuleTitle;
  eventKindId: string;
  totalDemand: number;
  coverage?: SchedulingObligationCoverage;
}
